import { useState } from 'react'
import PropTypes from 'prop-types'
import { X } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

import TextAreaField from '../../../../components/FormLegacy/FormFieldsV2/TextAreaField'

const ConfirmRevisionModal = ({ isOpen, isLoading, onCancel, onConfirm, body }) => {
  const { t } = useTranslation(['checklists-tasks', 'common'])
  const [revisionNote, setRevisionNote] = useState('')

  return (
    <div className={`modal modal--confirm-revision ${isOpen ? 'is-active' : ''}`}>
      <div className="modal-background" />
      <div className="modal-content">
        <div className="box">
          <header className="modal__header">
            <div>{t('checklists-tasks:confirmRevisionModal.title')}</div>
            <span onClick={onCancel}>
              <X size={24} />
            </span>
          </header>
          <div className="modal__body">{body}</div>
          <h3>{t('checklists-tasks:confirmRevisionModal.noteTitle')}</h3>
          <TextAreaField
            name="text-area-field"
            value={revisionNote}
            onChange={(e) => setRevisionNote(e.target.value)}
            maxLength="220"
            placeholder={t('checklists-tasks:confirmRevisionModal.notePlaceholder')}
          />
          <div className="text-area-limit-info">
            {t('checklists-tasks:confirmRevisionModal.maxLengthInfo')}
          </div>
          <div className="modal__footer">
            <button className="button button-gray" onClick={onCancel} disabled={isLoading}>
              {t('common:actions.cancel')}
            </button>
            <button
              className="button button-red"
              onClick={() => onConfirm(revisionNote)}
              disabled={isLoading}
            >
              {t('checklists-tasks:confirmRevisionModal.yesRequestRevisionButton')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

ConfirmRevisionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  body: PropTypes.string,
}

export default ConfirmRevisionModal
